import { AtlassianJiraConfluenceGridViewData, Column, ColumnKeys } from '../types';
import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import { translateFn } from '../../../../../utils/translator.helper';
import { ColumnDetails, ColumnType } from '../../../../../grid/types/common';
import { ViewType } from '../../../../../grid/gridView/types';

export class AtlassianJiraConfluenceGridBaseDataProvider extends BaseWebComponentDataProvider {
  private gridColumns: Array<ColumnDetails<Column, ColumnKeys>> = [
    {
      column: Column.ORGANIZATION_SITE_DOMAIN,
      key: ColumnKeys.ORGANIZATION_SITE_DOMAIN,
      columnName: translateFn('Organization site domain'),
      type: ColumnType.STRING,
      removable: false,
    },
    {
      column: Column.PRODUCT_ADMIN_EMAIL,
      key: ColumnKeys.PRODUCT_ADMIN_EMAIL,
      columnName: translateFn('Product admin email address'),
      type: ColumnType.STRING,
      removable: false,
    },
    {
      column: Column.JIRA,
      key: ColumnKeys.JIRA,
      columnName: translateFn('Jira'),
      type: ColumnType.CHECKBOX,
      removable: false,
    },
    {
      column: Column.CONFLUENCE,
      key: ColumnKeys.CONFLUENCE,
      columnName: translateFn('Confluence'),
      type: ColumnType.CHECKBOX,
      removable: false,
    },
    {
      column: Column.ACTIONS,
      key: ColumnKeys.ACTIONS,
      columnName: translateFn('Action'),
      type: ColumnType.ACTION,
      removable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
  ];

  public async getDataForView(): Promise<AtlassianJiraConfluenceGridViewData> {
    const view = {
      id: 'atlassian-jira-confluence-grid',
      name: translateFn('Default view'),
      type: ViewType.DEFAULT,
      filters: [],
      displayedColumns: [
        Column.ORGANIZATION_SITE_DOMAIN,
        Column.PRODUCT_ADMIN_EMAIL,
        Column.JIRA,
        Column.CONFLUENCE,
        Column.ACTIONS
      ],
      pageSize: 20,
      pageNumber: 1,
      compactView: false,
    };

    return {
      views: [view],
      allColumns: this.gridColumns,
      defaultViewProps: view,
    };
  }
}
